import useProducts from 'hooks/useProducts';
import ProductItem from './ProductItem';
import { EqualHeight } from 'react-equal-height/clean';

type ProductListProps = {
  query: string;
};

function ProductList({ query }: ProductListProps) {
  const { products } = useProducts(query);

  return (
    <EqualHeight>
      {products?.map((product) => (
        <ProductItem key={product.id} product={product}></ProductItem>
      ))}
    </EqualHeight>
  );
}

export default ProductList;
